import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from '@/utils/axios'
import 'lib-flexible'

import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios //引用axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
